/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 14:04:15
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-19 18:23:58
 * @FilePath: \crm-product\found\views\sfa\views\reports\display_fees\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, { formCreate } from '@/found/components/form';

import ProductRespVos from './product_info.vue';
import PhotoRespVos from './photo_list.vue';

formCreate.component('ProductRespVos', ProductRespVos);
formCreate.component('PhotoRespVos', PhotoRespVos);

export default {
  name: 'table-component',
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'display_fees_report_form',
    };
  },
  methods: {
    formComplete() {
      if (this.formConfig.code === 'view') {
        // this.setValue(this.formConfig.row);
        this.setValue({ ...this.formConfig.row, photoRespVos: this.formConfig.row });
        const tempData = this.formConfig.row;
        if (tempData && ((tempData.doorPhotoRespVos && tempData.doorPhotoRespVos.length !== 0) || (tempData.displayPhotoRespVos && tempData.displayPhotoRespVos.length !== 0) || (tempData.pickupsPhotoRespVos && tempData.pickupsPhotoRespVos.length !== 0))) {
          this.hiddenFields(false, ['photoRespVos', 'title2']);
        } else {
          this.hiddenFields(true, ['photoRespVos', 'title2']);
        }
        if (tempData && tempData.productRespVos && tempData.productRespVos.length !== 0) {
          this.hiddenFields(false, ['productRespVos', 'title1']);
        } else {
          this.hiddenFields(true, ['productRespVos', 'title1']);
        }
      }
    },
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'productRespVos') {
        v.props.value = this.formConfig.row.productRespVos || [];
      }
      if (v.field === 'photoRespVos') {
        // 整个 row 传入，组件内用 metadataVos 匹配图片上传时间
        v.props.value = this.formConfig.row || {};
      }
      return v;
    },
  },

};
